import { request } from "../utils/api";

const buildQuery = (params = {}) => {
  const entries = Object.entries(params).filter(
    ([, v]) => v !== undefined && v !== null && v !== "",
  );
  if (!entries.length) return "";
  return `?${new URLSearchParams(entries).toString()}`;
};

/** Search NPPES / custom physician catalog. */
export const searchNpiPhysicians = (params) =>
  request(`/physicians/npi/search${buildQuery(params)}`);

/** Create a new physician catalog row. */
export const createNpiPhysician = (data) =>
  request(`/physicians/npi`, {
    method: "POST",
    body: JSON.stringify(data),
  });
